<template lang="html">
  <v-dialog
    v-model="dialogQrcodRichMenu"
    scrollable
    fullscreen
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
  <v-card>
    <v-toolbar class="bg-toolbar">
      <v-toolbar-title class="ml-0">{{$t('Settings.Qrcode.header')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="black" flat icon dark @click="toPage()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-tabs
        slot="extension" v-model="tab" fixed-tabs color="transparent" icons-and-text centered
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          {{$t('Settings.Qrcode.myQRcode')}}
          <v-icon style="color: #2562af;">fas fa-qrcode</v-icon>
        </v-tab>

        <v-tab href="#tab-2">
          {{$t('Settings.Qrcode.scanQRcode')}}
          <v-icon style="color: #2562af;">mdi-qrcode-scan</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" style="overflow-y: scroll; height: calc(100vh - 164px);">
        <v-tab-item id="tab-1">
          <v-layout column wrap justify-center class="mt-3" align-center>
            <!-- <h4>คิวอาร์โค้ดของฉัน</h4> -->
            <qrcode :value="tokenuserQR" style="width: 180px; height: 180px;" id="downloadqruser" class="mt-3"></qrcode>
            <p class="SettingQrNote ml-4">{{$t('Settings.editProfile.detailQRcode')}}
            <a href="#" class="button" id="btn-download-user" :download="'qrcode_user_' + name + '.png'" @click="loadqr()">{{$t('AnswerQuestion.download')}}</a></p>
          </v-layout>
        </v-tab-item>
        <v-tab-item id="tab-2">
          <div v-if="alert_message !== 'NotAllowedError'">
            <qrcode-drop-zone @decode="onDecode" @init="logErrors">
              <qrcode-stream @decode="onDecode" @init="onInit" :camera="camera">
                <v-btn @click="switchCamera" outlined fab small style="float: right; margin-top: 40px;">
                  <v-icon style="color: #2562af; font-size: 24px;">switch_camera</v-icon>
                </v-btn>
              </qrcode-stream>
            </qrcode-drop-zone>
            <!-- <qrcode-capture v-if="noStreamApiSupport" @decode="onDecode" /> -->
            <qrcode-capture
            @decode="onDecode"
            :multiple="false"
            type="file"
            name="image"
            accept="image/*"
            capture="environment"
            style="display: none !important;"
            id="qrcode-capture-mobile"/>

            <!-- <input
            type="file"
            name="image"
            accept="image/*"
            capture="environment"
            multiple
            /> -->
          </div>
          <div v-else>
            <v-layout row wrap justify-center align-center class="mt-4">
              <!-- <qrcode-capture @decode="onDecode" style="display: none !important;" id="qrcode-capture-mobile"/> -->
              <h4>{{$t('Settings.Qrcode.openCamera')}}</h4>
              <qrcode-capture
              @decode="onDecode"
              :multiple="false"
              type="file"
              name="image"
              accept="image/*"
              capture="environment"
              style="display: none !important;"
              id="qrcode-capture-mobile"/>

              <!-- <input
              type="file"
              name="image"
              accept="image/*"
              capture="environment"
              multiple
              @click="upfile"
              /> -->
            </v-layout>
          </div>
          <v-layout row wrap align-center justify-center class="mt-3">
            <v-btn @click="upfileqrcode()" class="btn-upfileqrcode">{{$t('AnswerQuestion.selectPicture')}}</v-btn>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
  </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import { Decode } from '@/services'
import VueQrcode from '@xkeshi/vue-qrcode'
import InforfriendDialogMobile from '@/components/mobile/dialog/InforfriendDialogMobile'
import vue100vh from 'vue-100vh'

Vue.component(VueQrcode.name, VueQrcode)
export default {
  props: {
    dialogQrcodRichMenu: Boolean,
    tokenroom: String,
    QrcodeInfor: {}
  },
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
    InforfriendDialogMobile,
    vue100vh
  },
  data () {
    return {
      result: '',
      noStreamApiSupport: false,
      tab: 'tab-2',
      tokenuserQR: '',
      tokenuser: '',
      name: '',
      camera: 'auto',
      noRearCamera: false,
      noFrontCamera: false,
      tokeninforfriend: '',
      inforfrienddialog: false,
      type: '',
      alert_message: ''
    }
  },
  created () {
    this.name = localStorage.getItem('name')
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = decoded['tokenuser']
    this.tokenuserQR = process.env.APIQRcode + '/qrcode/friend?id=' + btoa(this.tokenuser)
    this.camera = 'off'
  },
  watch: {
    tab () {
      if (this.tab == 'tab-2') {
        this.camera = 'auto'
      } else {
        this.camera = 'off'
      }
    },
    dialogQrcodRichMenu () {
      // console.log(this.dialogQrcodRichMenu)
      // console.log(this.tokenroom)
      if (this.dialogQrcodRichMenu) {
        this.camera = 'auto'
      } else {
        this.camera = 'off'
      }
    }
  },
  // mounted: {
  //   onInit () {
  //     this.onInit()
  //   }
  // },
  methods: {
    // upfile () {
    //   $('#qrcode-capture-mobile').click()
    // },
    upfileqrcode () {
      $('#qrcode-capture-mobile').click()
      // $('#inputfile').click()
    },
    closeInforfriend () {
      this.inforfrienddialog = false
      this.tokeninforfriend = ''
      this.result = ''
    },
    toPage () {
      // this.$router.push('/mobile/homepage')
      this.camera = 'off'
      this.$emit('closedialogQrcode',false)
    },
    onDecode (result) {
      // console.log(result)
      // alert(result)
      this.result = result
      if (this.result != '') {
        // this.checkonechat(result)
        this.sendScanQrcode(result)
      } else {
        // alert(result)
        console.log(result)
      }
    },
    sendScanQrcode (url) {
      if (this.QrcodeInfor.status === 'false') {
        this.axios.post(process.env.APIalpine + '/api/v1/qrcode-scan', {
          tokenuser: this.tokenuser,
          tokenroom: this.tokenroom,
          data: url
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            // this.$swal('', 'ส่งข้อมูลสำเร็จ', 'success')
            this.$swal('', this.$t('Alert.Success.success'), 'success')
            this.toPage()
          }
        }).catch(error => {
          console.log(error)
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      } else {
        this.axios.post(process.env.APIQRcodeLoation, {
          tokenuser: this.tokenuser,
          tokenroom: this.tokenroom,
          data: url,
          lat: this.QrcodeInfor.lat,
          long: this.QrcodeInfor.lng,
          address: this.QrcodeInfor.address
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            // this.$swal('', 'ส่งข้อมูลสำเร็จ', 'success')
            this.$swal('', this.$t('Alert.Success.success'), 'success')
            this.toPage()
          }
        }).catch(error => {
          console.log(error)
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    checkonechat (url) {
      // console.log(url)
      if (url.includes(process.env.API + '/qrcode/friend?id=')){
        var code = url.split(process.env.API + '/qrcode/friend?id=')
        this.tokeninforfriend = atob(code[1])
        // console.log(this.tokeninforfriend)
        localStorage.setItem('typefriend', 'friend')
        this.$router.push('/mobile/profilefriend/' + this.tokeninforfriend)
        // this.type = 'friend'
        // this.inforfrienddialog = true
      } else if (url.includes(process.env.API + '/qrcode/group?id=')){
        var code = url.split(process.env.API + '/qrcode/group?id=')
        this.tokeninforfriend = atob(code[1])
        // console.log(this.tokeninforfriend)
        // this.type = 'group'
        // this.inforfrienddialog = true
        localStorage.setItem('typefriend', 'group')
        this.$router.push('/mobile/profilefriend/' + this.tokeninforfriend)
      } else {
        this.$swal({
          text: this.$t('Settings.Qrcode.resultScan') + url,
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: this.$t('AnswerQuestion.open'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            window.open(url)
            this.closeInforfriend()
          } else {
            this.closeInforfriend()
          }
        })
      }
    },
    logErrors (promise) {
      promise.catch(console.error)
    },
    loadqr () {
      var cnvs = document.getElementById('downloadqruser')
      var button = document.getElementById('btn-download-user')
      var dataURL = cnvs.toDataURL('image/png')
      button.href = dataURL
    },
    closeCamera () {
      // console.log('obj')
      this.camera = 'off'
    },
    switchCamera () {
      // console.log(this.camera)
      switch (this.camera) {
        case 'front':
          this.camera = 'auto'
          // console.log(this.camera)
          // alert(this.camera)
          break
        case 'rear':
          this.camera = 'auto'
          // console.log(this.camera)
          // alert(this.camera)
          break
        case 'auto':
          this.camera = 'front'
          // console.log(this.camera)
          // alert(this.camera)
          break
      }
    },
    async onInit (promise) {
      // console.log(promise)
      // alert(promise)
      try {
        // console.log(promise)
        // alert(promise)
        await promise
      } catch (error) {
        // console.log(error)
        // console.log(error.name)
        // alert(error)
        const triedFrontCamera = this.camera === 'front'
        const triedRearCamera = this.camera === 'rear'

        const cameraMissingError = error.name === 'OverconstrainedError'

        if (triedRearCamera && cameraMissingError) {
          this.noRearCamera = true
        }

        if (triedFrontCamera && cameraMissingError) {
          this.noFrontCamera = true
        }
        if (error.name === 'StreamApiNotSupportedError') {
          this.noStreamApiSupport = true
        } else if (error.name === 'NotAllowedError') {
          // console.log('กรุณาอนุญาตการใช้งานกล้อง')
          this.alert_message = 'NotAllowedError'
          // if('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices){
          //   navigator.permissions.query({name: 'camera'})
          //    .then((permissionObj) => {
          //     console.log(permissionObj)
          //     console.log(permissionObj.state)
          //    })
          //    .catch((error) => {
          //     console.log('Got error :', error)
          //    })
          // }
        }
      }
    }
  }
}
</script>
<style media="screen" scoped>
.btn-upfileqrcode {
  /* border-style: solid; */
  border-radius: 30px !important;
  width: 180px !important;
  background-color: #2561b0 !important;
  color: white !important;
  height: 35px !important;
}
.bg-toolbar {
    background-color: white;
}
>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
}
>>>.camera {
  width: 300px;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/QrCodeRichMenuDialog.vue